function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st003{fill:url(#SVGID_120_);}\n\t.st103{fill:#F7931E;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st003",
  d: "M42,64H22C9.9,64,0,54.1,0,42V22C0,9.9,9.9,0,22,0h20c12.1,0,22,9.9,22,22v20C64,54.1,54.1,64,42,64z M22,2 C11,2,2,11,2,22v20c0,11,9,20,20,20h20c11,0,20-9,20-20V22c0-11-9-20-20-20H22z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(16 13)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st103",
  d: "M16,15.9c-4.4,0-8-3.6-8-7.9S11.6,0,16,0s8,3.6,8,7.9S20.4,15.9,16,15.9z M16,3c-2.8,0-5,2.2-5,4.9 s2.2,4.9,5,4.9s5-2.2,5-4.9S18.8,3,16,3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st103",
  d: "M16,37c-5.4,0-10.7-1.7-15.1-4.8L0,31.6l0.3-1C2.2,23.5,8.7,18.5,16,18.5s13.8,5,15.8,12.1l0.3,1l-0.9,0.6 C26.7,35.3,21.5,37,16,37C16,37,16,37,16,37z M3.5,30.4c3.7,2.4,8,3.6,12.5,3.6c0,0,0,0,0.1,0c4.5,0,8.8-1.3,12.5-3.6 c-1.9-5.3-6.9-8.9-12.5-8.9C10.4,21.5,5.3,25.1,3.5,30.4z"
})));

var SvgUserBig = function SvgUserBig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_120_",
    gradientUnits: "userSpaceOnUse",
    x1: -458.7957,
    y1: 524.9677,
    x2: -459.1398,
    y2: 524.9677,
    gradientTransform: "matrix(62 0 0 -62 28488 32580)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAB535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931E"
    }
  })), _ref3), _ref4));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserBig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-big.9540114a.svg";
export { ForwardRef as ReactComponent };